<div class="bmc-ai-jobs-list">
  <h4 class="bz-font-weight--semibold">{{'AIJOBS.AIJOB_LIST' | translate}}</h4>
  <div class="search-container">
    <div class="bmc-ai-jobs-list__search-box bz-border-radius--m">
      <bzg-input [placeholder]="('AIJOBS.SEARCH' | translate)" class="bmc-ai-jobs-list__search-box__text" name="search-box" [(ngModel)]="searchValue" actionIcnPosition="right">
        <bzg-icon nameIcon="icon-search"></bzg-icon>
      </bzg-input>
    </div>
    <bz-filter [configuration]="configurationFilter" (change)="onFilterChange($event)"></bz-filter>
  </div>

  <ul class="bmc-ai-jobs-list__items">
    <li class="bmc-ai-jobs-list__item bz-shadow--xs bz-border-radius--m" [ngClass]="{'bz-color-bg--theme-100': userJob === selectedJob}" *ngFor="let userJob of userJobs | AIJobsList:searchValue | AIJobsListStatus:selectedFilterStatus | AIJobsListStatusExcecution:selectedFilterExecutionStatus" (click)="setCurrentJob(userJob)">
      <div class="bz-font-weight--semibold bz-color-item-level-1" >{{userJob.name}}</div>
            <div *ngIf="userJob.enabled">
        <div class="bmc-ai-jobs-list__item__middle-text bz-color-item-level-1">
          <span *ngIf="!isNextRuntimeYear9999(userJob)">
            <span class="bz-font-weight--regular bz-color--neutral-400">{{'USERJOBS.NEXT_RUN_TIME' | translate}}:</span> 
            <span class="bz-color-label"> {{ (userJob.nextRuntime | userTimezoneFormat:10) || ('USERJOBS.NOT_DEFINED' | translate) }}</span>
          </span>
          <svg class="bz-icn bz-icon-svg--16" *ngIf="!isNextRuntimeYear9999(userJob)">
            <use href="#icon-arrow-right-bold"></use>
          </svg>
        </div>
        <div class="bmc-ai-jobs-list__item__middle-text">
          <div class="bmc-ai-jobs-status-container bz-color-item-level-2">
            <span class="bz-font-weight--regular bz-color--neutral-400">{{ 'USERJOBS.CONFIGURATION' | translate}}:</span>
            <div class="bmc-ai-jobs-list__item__bottom-text bz-font-style--italic bz-color--theme-400" style="margin: 0;">
              {{ 'USERJOBS.ENABLED' | translate}}
            </div>
            <span class="bz-font-weight--regular bz-color-separator">|</span>
            <span class="bz-font-weight--regular bz-color--neutral-400">{{ 'USERJOBS.LAST_EXECUTION' | translate}}:</span>
            <span class="bmc-ai-jobs-list__item__bottom-text bz-font-style--italic" style="margin: 0;" [ngClass]="lastExecutionStatusColors(userJob)">{{lastExecutionStatus(userJob)}}</span>
          </div>
          <svg class="bz-icn bz-icon-svg--16" *ngIf="isNextRuntimeYear9999(userJob)">
            <use href="#icon-arrow-right-bold"></use>
          </svg>
        </div>
      </div>
      <div *ngIf="!userJob.enabled">
        <div class="bmc-ai-jobs-list__item__middle-text bz-color-item-level-1">
          {{'USERJOBS.LAST_EXECUTED_TIME' | translate}}:
          <span class="bmc-ai-jobs-list__item__middle-text-space bz-color-label"  *ngIf="userJob.lastProcessingTime">{{userJob.lastProcessingTime | userTimezoneFormat:10 }}</span>
          <span class="bmc-ai-jobs-list__item__middle-text-space bz-color-label"  *ngIf="!userJob.lastProcessingTime">{{'USERJOBS.NOT_EXECUTED' | translate}}</span>
          <svg class="bz-icn bz-icon-svg--16">
            <use href="#icon-arrow-right-bold"></use>
          </svg>
        </div>
        <div class="bmc-ai-jobs-status-container bz-color-item-level-2">
          <span class="bz-font-weight--regular  bz-color--neutral-400">{{ 'USERJOBS.CONFIGURATION' | translate}}:</span>
          <div class="bmc-ai-jobs-list__item__bottom-text bz-font-style--italic  bz-color--neutral-400"   style="margin: 0; color: #9e9e9e;">
            {{ 'USERJOBS.DISABLED' | translate}}
          </div>
          <span class="bz-font-weight--regular  bz-color-separator">|</span>
          <span class="bz-font-weight--regular  bz-color--neutral-400">{{ 'USERJOBS.LAST_EXECUTION' | translate}}:</span>
          <span class="bmc-ai-jobs-list__item__bottom-text bz-font-style--italic" style="margin: 0;" [ngClass]="lastExecutionStatusColors(userJob)">{{lastExecutionStatus(userJob)}}</span>
        </div>
      </div>
    </li>
  </ul>
</div>